/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliTeacherInstitutionDto } from '../../models/amoxcalli-teacher-institution-dto';

export interface ApiTeacherInstitutionsMineGet$Plain$Params {
}

export function apiTeacherInstitutionsMineGet$Plain(http: HttpClient, rootUrl: string, params?: ApiTeacherInstitutionsMineGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliTeacherInstitutionDto>>> {
  const rb = new RequestBuilder(rootUrl, apiTeacherInstitutionsMineGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliTeacherInstitutionDto>>;
    })
  );
}

apiTeacherInstitutionsMineGet$Plain.PATH = '/api/teacher-institutions/mine';
